/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

const inputCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent";

const Field = ({ label, required, error, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">
      {label}{required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

function Guarantor() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    SubmitUpdateLoanFormOne,
    ResetUserDataResponse,
    GetFormOneAppliedLoanTemp,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(2);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState({});

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
  }, []);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      guarantor_name:           loanTemp?.guarantor_name,
      guarantor_staff_id:       loanTemp?.guarantor_staff_id,
      guarantor_phone:          loanTemp?.guarantor_phone,
      guarantor_ghana_card:     loanTemp?.guarantor_ghana_card,
      guarantor_gps:            loanTemp?.guarantor_gps,
      guarantor_occupation:     loanTemp?.guarantor_occupation,
      guarantor_mandate_number: loanTemp?.guarantor_mandate_number,
      guarantor_otp_number:     loanTemp?.guarantor_otp_number,
      guarantor_relationship:   loanTemp?.guarantor_relationship,
      guarantor_name2:           loanTemp?.guarantor_name2,
      guarantor_staff_id2:       loanTemp?.guarantor_staff_id2,
      guarantor_phone2:          loanTemp?.guarantor_phone2,
      guarantor_ghana_card2:     loanTemp?.guarantor_ghana_card2,
      guarantor_gps2:            loanTemp?.guarantor_gps2,
      guarantor_occupation2:     loanTemp?.guarantor_occupation2,
      guarantor_mandate_number2: loanTemp?.guarantor_mandate_number2,
      guarantor_otp_number2:     loanTemp?.guarantor_otp_number2,
      guarantor_relationship2:   loanTemp?.guarantor_relationship2,
    }));
  }, [loanTemp]);

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const validateForm = () => {
    const err = {};
    const req = (key, msg) => { if (!formData[key]) err[key] = msg; };
    req("guarantor_name",           "Guarantor name is required");
    req("guarantor_staff_id",       "Guarantor Staff ID is required");
    req("guarantor_phone",          "Guarantor phone number is required");
    req("guarantor_ghana_card",     "National ID number of guarantor is required");
    req("guarantor_gps",            "Guarantor GPS address is required");
    req("guarantor_occupation",     "Guarantor occupation is required");
    req("guarantor_mandate_number", "Guarantor Mandate number is required");
    req("guarantor_otp_number",     "Guarantor OTP number is required");
    req("guarantor_relationship",   "Guarantor relationship is required");
    req("guarantor_name2",           "Guarantor name is required");
    req("guarantor_staff_id2",       "Guarantor Staff ID is required");
    req("guarantor_phone2",          "Guarantor phone number is required");
    req("guarantor_ghana_card2",     "National ID number of guarantor is required");
    req("guarantor_gps2",            "Guarantor GPS address is required");
    req("guarantor_occupation2",     "Guarantor occupation is required");
    req("guarantor_mandate_number2", "Guarantor Mandate number is required");
    req("guarantor_otp_number2",     "Guarantor OTP number is required");
    req("guarantor_relationship2",   "Guarantor relationship is required");
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleFormSubmitHandler = (e) => {
    e.preventDefault();
    if (validateForm()) {
      SubmitUpdateLoanFormOne({ ...loanTemp, ...formData }, loanTemp?._id);
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      ResetUserDataResponse();
      history.push("/apply-loan-employment");
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan">
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <form onSubmit={(e) => e.preventDefault()} style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          {/* ── Guarantor 1 ── */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Guarantor 1</h3>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Full Name" required error={formError.guarantor_name}>
                <input type="text" name="guarantor_name"
                  defaultValue={loanTemp?.guarantor_name}
                  placeholder="Guarantor's full name" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Staff ID" required error={formError.guarantor_staff_id}>
                <input type="text" name="guarantor_staff_id"
                  defaultValue={loanTemp?.guarantor_staff_id}
                  placeholder="Guarantor's staff ID" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Phone Number" required error={formError.guarantor_phone}>
                <input type="text" name="guarantor_phone"
                  defaultValue={loanTemp?.guarantor_phone}
                  placeholder="Guarantor's phone number" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Ghana Card Number" required error={formError.guarantor_ghana_card}>
                <input type="text" name="guarantor_ghana_card"
                  defaultValue={loanTemp?.guarantor_ghana_card}
                  placeholder="Ghana Card number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="GPS Address" required error={formError.guarantor_gps}>
                <input type="text" name="guarantor_gps"
                  defaultValue={loanTemp?.guarantor_gps}
                  placeholder="GPS address" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Occupation" required error={formError.guarantor_occupation}>
                <input type="text" name="guarantor_occupation"
                  defaultValue={loanTemp?.guarantor_occupation}
                  placeholder="Occupation" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Mandate Number" required error={formError.guarantor_mandate_number}>
                <input type="text" name="guarantor_mandate_number"
                  defaultValue={loanTemp?.guarantor_mandate_number}
                  placeholder="Mandate number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="OTP Number" required error={formError.guarantor_otp_number}>
                <input type="text" name="guarantor_otp_number"
                  defaultValue={loanTemp?.guarantor_otp_number}
                  placeholder="OTP number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Relationship" required error={formError.guarantor_relationship}>
                <input type="text" name="guarantor_relationship"
                  defaultValue={loanTemp?.guarantor_relationship}
                  placeholder="Relationship to borrower" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <p className="text-sm text-gray-600 bg-gray-50 rounded-md p-3">
              I <strong className="underline">{formData.guarantor_name || loanTemp?.guarantor_name || '___'}</strong> hereby
              declare that in the event the borrower fails to make payments or honor the contractual agreement herein signed,
              I guarantee to make full payment to UPNMG-FUND in the same way as if I were the original entity of the said
              agreement except the default is in respect of death. (GUARANTOR MUST BE A MEMBER OF UPNMG IN GOOD STANDING)
            </p>
          </div>

          {/* ── Guarantor 2 ── */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Guarantor 2</h3>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Full Name" required error={formError.guarantor_name2}>
                <input type="text" name="guarantor_name2"
                  defaultValue={loanTemp?.guarantor_name2}
                  placeholder="Guarantor's full name" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Staff ID" required error={formError.guarantor_staff_id2}>
                <input type="text" name="guarantor_staff_id2"
                  defaultValue={loanTemp?.guarantor_staff_id2}
                  placeholder="Guarantor's staff ID" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Phone Number" required error={formError.guarantor_phone2}>
                <input type="text" name="guarantor_phone2"
                  defaultValue={loanTemp?.guarantor_phone2}
                  placeholder="Guarantor's phone number" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Ghana Card Number" required error={formError.guarantor_ghana_card2}>
                <input type="text" name="guarantor_ghana_card2"
                  defaultValue={loanTemp?.guarantor_ghana_card2}
                  placeholder="Ghana Card number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="GPS Address" required error={formError.guarantor_gps2}>
                <input type="text" name="guarantor_gps2"
                  defaultValue={loanTemp?.guarantor_gps2}
                  placeholder="GPS address" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Occupation" required error={formError.guarantor_occupation2}>
                <input type="text" name="guarantor_occupation2"
                  defaultValue={loanTemp?.guarantor_occupation2}
                  placeholder="Occupation" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Mandate Number" required error={formError.guarantor_mandate_number2}>
                <input type="text" name="guarantor_mandate_number2"
                  defaultValue={loanTemp?.guarantor_mandate_number2}
                  placeholder="Mandate number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="OTP Number" required error={formError.guarantor_otp_number2}>
                <input type="text" name="guarantor_otp_number2"
                  defaultValue={loanTemp?.guarantor_otp_number2}
                  placeholder="OTP number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Relationship" required error={formError.guarantor_relationship2}>
                <input type="text" name="guarantor_relationship2"
                  defaultValue={loanTemp?.guarantor_relationship2}
                  placeholder="Relationship to borrower" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <p className="text-sm text-gray-600 bg-gray-50 rounded-md p-3">
              I <strong className="underline">{formData.guarantor_name2 || loanTemp?.guarantor_name2 || '___'}</strong> hereby
              declare that in the event the borrower fails to make payments or honor the contractual agreement herein signed,
              I guarantee to make full payment to UPNMG-FUND in the same way as if I were the original entity of the said
              agreement except the default is in respect of death.
            </p>
          </div>

          <div className="flex justify-between mt-2">
            <button type="button"
              onClick={() => history.push("/apply-loan-personal_info")}
              className="px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none">
              Back
            </button>
            <button type="button" onClick={handleFormSubmitHandler}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none">
              Save and continue
            </button>
          </div>

        </form>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default Guarantor;
